import React from 'react';

const HistoryOfTemperatureTakers = () => {
  return (
    <div>
      <h1>History of Brighton Icebergers water temperature takers</h1>
      <p>A brief History of Brighton Icebergers water temperature takers.</p>
      <p>
        The taking and recording of the daily water temperature at Brighton
        started in the early 1970s with Harry Raisbeck (our late and esteemed
        'president for life'). Harry was a calligrapher by occupation and his
        charts which were drawn on poster-size graph paper were a work of art.
      </p>
      <img
        src="/blog-temp-takers.jpg"
        alt="Middle Brighton Baths Water Temperature"
      />
      <p>
        One of Harry Raisbeck’s sea water temperature charts from 1989.
      </p>
      <p>
        Billy Dodds (a real Iceberger character) was Harry's assistant
        temperature taker until the mid-1980's when Billy went away for a few
        months. Harry then seconded me and I became Harry's assistant after
        receiving Harry's training (the temperature was taken daily at 5.15
        am, halfway between the two steps, southern side of the Baths and at a
        depth of 2 foot). This regimented daily procedure no doubt had
        something to do with Harry's army background!
      </p>
      <p>
        Back then, the thermometer was a large analogue one which Harry needed
        to recalibrate from time to time. He did so by first placing it first
        in an ice bath (for 0 deg) and then in boiling water before adjusting
        the scale and holding the scale in place with blu tack.
      </p>
      <p>
        When we all moved from the baths to RBYC, in order to enable the
        conversion of the baths into what it is today, Harry continued taking
        the temperature until into his late 90's when he could no longer come
        down. A fairly short time later he died 15 days shy of his 100th
        birthday.
      </p>
      <p>
        Douglas Weir, having commenced swimming with us in the late 1990s, and
        being retired, took over the mantle of senior temperature taker with
        Gary Liddell and myself being the assistants.
      </p>
      <p>
        All was good until Dougie could no longer come down, leaving Gary and
        me to take the daily temperatures.
      </p>
      <p>
        Again, all was good until Gary could no longer come down, leaving me as
        the sole purveyor of the temperature taking.
      </p>
      <p>
        Temperature takers: David Tonkin, Doug Weir, Gary Liddell, Photo by Ria
        Bleathman 10/12/20
      </p>
      <p>
        Having approached other daily 5.00 am swimmers to assist in the taking
        of the temperature (all having very good reasons why they couldn't!)
        there had been little backup. This was fine, except for when I'm
        swimming in the pristine waters of Cape Woolamai.
      </p>
      <p>
        This tyranny of distance coupled with some ongoing issues with the
        thermometer (our digital thermometer is currently on the blink again and
        Phil, RBYC manager, is now sourcing a more reliable brand - thanks
        Phil) has meant the temperature board hasn't been regularly updated, a
        fact which I'm sure most of you would know.
      </p>
      <p>
        Paul McGuire upon hearing of this plight readily volunteered to attend
        the compulsory 2-minute training course and he is now an
        official Iceberger-approved assistant temperature taker and whiteboard
        monitor. Many thanks, Paul.
      </p>
      <p>
        Once we get our new thermometer the board will again be updated daily.
        Thank you for your patience.
      </p>
      <p>Please be kind to him. It can be a thankless task☹️</p>
      <p>Your humble servant</p>
      <p>David Tonkin</p>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default HistoryOfTemperatureTakers;
